// CSS imports
// Application entry point for lingk-platform-ui
import config from '@/config';
import '@/rum';
import '@/styles/elevio-overrides.css';

import { StrictMode } from 'react';

import 'react-big-calendar/lib/css/react-big-calendar.css';
import { createRoot } from 'react-dom/client';

import { logger } from '@/utils/logger';

import App from './App';

// Validate critical environment config on startup
const requiredUrls = ['API_URL', 'AUTH0_DOMAIN', 'AUTH0_CLIENT_ID', 'AUTH0_AUDIENCE'] as const;
for (const key of requiredUrls) {
  if (!config[key]) {
    logger.error(
      `[ENV] Missing required config: ${key} is "${config[key]}". ` +
        'Ensure environment variables are set at build time.'
    );
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
